import React, {FC, useState} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTIcon, WithChildren} from '../../../../helpers'
import {useLayout} from '../../../core'

type Props = {
  to: string
  title: string
  icon?: string | JSX.Element
  fontIcon?: string
  hasBullet?: boolean
  variant?: 'default' | 'accordion'
}


const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  variant = 'default',
}) => {
  const {pathname} = useLocation()
  const isActive = pathname === to
  const {config} = useLayout()
  const {app} = config

  const [openItem, setOpenItem] = useState<string | null>(null)
  const wrapperClass =
    variant === 'accordion' ? 'menu-item menu-accordion menu-main-p' : 'menu-item menu-item-main'
  const linkClass =
    variant === 'accordion' ? 'menu-link menu-link-p m-0' : 'menu-link without-sub py-5'

  return (
    <div className={wrapperClass}>
      <Link className={clsx(linkClass, {active: isActive})} to={to}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {typeof icon === 'string' && app?.sidebar?.default?.menu?.iconType === 'svg' && (
          <span className='menu-icon'>
            {' '}
            <KTIcon iconName={icon} className='fs-2' />
          </span>
        )}
        {React.isValidElement(icon) && <span className='menu-icon'>{icon}</span>}
        {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
          <i className={clsx('bi fs-3', fontIcon)}></i>
        )}
        <span className='menu-title'>{title}</span>
      </Link>
      {children}
    </div>
  )
}

export {SidebarMenuItem}
